import { DRFListResponseWrapper, getGlobalHeadersAsObject } from "..";

type Person = {
	id: number;
	name: string;
};

export type LinkedinJobPosting = {
	id: number;
	created: string;
	updated: string;
	company: number;
	job_title: string;
	listed_at: string;
	expire_at: string;
	location: number;
	location_name: string;
	company_name: string;
	urn: string;
	description_text: string;
	persons: Person[];
	unavailable: boolean;
	url: string;
	company_overview: string;
	company_website: string;
	company_url: string;
	company_location: string;
	company_total_ammount_employees: string;
	company_ammount_employees_cache: string;
};

export type LinkedinJobPostingQueryParams = {
	company?: number;
	person?: number;
};

export const getLinkedinJobPostingsByPersonId = (
	personId: number
): Promise<DRFListResponseWrapper<LinkedinJobPosting[]>> => {
	return fetch(`/api/v2/linkedin_job_posting/?persons=${personId}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const getLinkedinJobPostings = (
	queryParams: LinkedinJobPostingQueryParams
): Promise<DRFListResponseWrapper<LinkedinJobPosting[]>> => {
	const params = new URLSearchParams();
	if (queryParams.company) {
		params.append("company", queryParams.company.toString());
	}
	if (queryParams.person) {
		params.append("person", queryParams.person.toString());
	}

	return fetch(`/api/v2/linkedin_job_posting/?${params.toString()}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const getLinkedinJobPostingById = (id: number): Promise<LinkedinJobPosting> => {
	return fetch(`/api/v2/linkedin_job_posting/${id}/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
